import { useIntl } from "react-intl";
import AddIcon from '@mui/icons-material/Add';
import { IconButton, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { columnTypeToIcon, ColumnTypes } from "../helpers/columnUtils";

const Column = ({ labelText, onClick, type }) => {
  const IconComponent = columnTypeToIcon[type];
  return (
    <ListItem
      secondaryAction={
        <IconButton edge="end" aria-label="add" onClick={() => onClick(type)}>
          <AddIcon />
        </IconButton>
      }
    >
      <ListItemIcon>
        {IconComponent && <IconComponent />}
      </ListItemIcon>
      <ListItemText primary={labelText} />
    </ListItem>
  );
};

const StringColumn = (props) => {
  const intl = useIntl();
  return (
    <Column {...props} labelText={intl.formatMessage({ id: "project.stringColumn" })} type={ColumnTypes.STRING} />
  );
};

const NumberColumn = (props) => {
  const intl = useIntl();
  return (
    <Column {...props} labelText={intl.formatMessage({ id: "project.numberColumn" })} type={ColumnTypes.NUMBER} />
  );
};

const DateColumn = (props) => {
  const intl = useIntl();
  return (
    <Column {...props} labelText={intl.formatMessage({ id: "project.dateColumn" })} type={ColumnTypes.DATE} />
  );
};

const StatusColumn = (props) => {
  const intl = useIntl();
  return (
    <Column {...props} labelText={intl.formatMessage({ id: "project.statusColumn" })} type={ColumnTypes.STATUS} />
  );
};

const TimeReportColumn = (props) => {
  const intl = useIntl();
  return (
    <Column {...props} labelText={intl.formatMessage({ id: "project.timeReportColumn" })} type={ColumnTypes.TIME_REPORT} />
  );
};

export { StringColumn, NumberColumn, DateColumn, StatusColumn, TimeReportColumn };
